import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdbookingService } from '../services/adbooking.service';
import { PaymentdetailsService } from '../search-booking/paymentdetailstab.service';

@Component({
  selector: 'app-cancelorder',
  templateUrl: './cancelorder.component.html',
  styleUrls: ['./cancelorder.component.css']
})
export class CancelorderComponent implements OnInit {
  orderid: any;
  bookingdetail: any;
  email: any;
  freedays: any;
  totalCost: any;
  noofdays: any;
  adcategory: any;
  paymentdetails: any;
  payment_method: any;
  location: any;
  adtype: any;
  adpage: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private paymentdetailsService:PaymentdetailsService,
    private adbookingservice: AdbookingService) { 
      this.route.params.subscribe(

        params => {
          console.log(params);
        this.orderid = params.orderid;
          console.log(this.orderid);
      
      
      
      this.paymentdetailsService.getadcustdetails(this.orderid).subscribe(
        resp => {
          this.bookingdetail = resp.bookingdetails;
          this.email = this.bookingdetail.email;
          this.orderid = this.bookingdetail.orderid;
          this.adcategory = this.bookingdetail.adcategory;
           this.noofdays = this.bookingdetail.noofdays;
           this.adtype = this.bookingdetail.adtype;
           this.adpage = this.bookingdetail.adpage;
           this.location = this.bookingdetail.location
         
         
           this.totalCost = (this.bookingdetail.totalCost).toFixed(2);
         
        
           this.freedays = this.bookingdetail.freedays;

           this.paymentdetails = resp.paymentdetails;
           this.payment_method = this.paymentdetails.payment_method;
           console.log(this.email)
           console.log(this.freedays)
           
      
        
      
          
       });
      
      },
      error => console.log(error)
      );
      
    }

  ngOnInit() {
  }

}
